exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul{\r\n  list-style: none;\r\n  font-size: 1.3em;\r\n}\r\nli{\r\n  margin-bottom: .5em;\r\n  display: block;\r\n}\r\n@media screen and (max-width: 600px){\r\n  ul{\r\n    list-style: none;\r\n    font-size: 1.2em;\r\n  }\r\n  li{\r\n    margin-bottom: .5em;\r\n    display: block;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/banaszak60/src/app/main/scientific-comittee/scientific-comittee.component.css
// module id = ../../../../../src/app/main/scientific-comittee/scientific-comittee.component.css
// module chunks = main